export default "__VITE_PUBLIC_ASSET__039e36f8__"